import throttle from 'lodash/throttle';
import VectorLayer from 'ol/layer/Vector';
import Vector from 'ol/source/Vector';
import Collection from 'ol/Collection';
import GeoJSON from 'ol/format/GeoJSON';

import connectRefluxGeoJsonStoreToOlVectorSource from '../../reflux-geojson-store-to-ol-vector-source-connector';
import dataStore from '../../stores/data-store';
import defaultStyleFunctionFactory from '../styles/default';
import debugStyleFunctionFactory from '../styles/debug';

export default function dataLayer({enableDataEditing = false} = {}) {
	const dataVectorLayer = new VectorLayer({
		updateWhileInteracting: true,
		updateWhileAnimating: true,
		source: new Vector(
			enableDataEditing ? {features: new Collection()} : {}
		),
		style: (enableDataEditing
			? debugStyleFunctionFactory
			: defaultStyleFunctionFactory)(dataStore),
	});

	connectRefluxGeoJsonStoreToOlVectorSource(
		dataStore,
		dataVectorLayer.getSource(),
		new GeoJSON(),
		throttle((data, cb) => cb(data), 1200)
	);

	return dataVectorLayer;
}
